import * as React from "react";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  FormControl,
  FormGroup,
} from "react-bootstrap";
import { FiChevronDown } from "react-icons/fi";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import BootstrapTable from "react-bootstrap-table-next";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import { resolve, reject } from "q";
import { confirmAlert } from "react-confirm-alert";
import { ToastContainer, toast } from "react-toastify";
import paginationFactory from "react-bootstrap-table2-paginator";

import { User } from "../../Common/Services/User";
import { RolePremissionSlideout } from "./RolePremissionSlideout";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import _ from "lodash";

import createDOMPurify from "dompurify";

import moment from "moment";
import { Roles, RolesforTreeView } from "../../Common/Services/RolePermissionSetting";
import { idText } from "typescript";
const columns = [
  {
    dataField: "roleName",
    text: "Role",
  },
  {
    dataField: "roleName",
    text: "Role",
    hidden: true,    
    //style:{ backgroundColor: '#c8e6c9':'none' },
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        
       <div style={{backgroundColor: 'none'}}>
          {row.roleName}
          </div>
      );
    },
  },
];

const pcolumns = [
  {
    dataField: "displayPermissionName",
    text: "",
    headerStyle: () => ({ display: 'none' }),
    headerFormatter: () => null,
    formatter: (cell: any, row: any, rowIndex: any, extraData: any) => {
      const permissionData = extraData?.permissionData || [];
      
      if (row.levelInfo === 1) {
        // Level 1: Count all descendants (level 2 and level 3)
        const allLevel2 = permissionData.filter(
          (p: any) => p.parentId === row.permissionId && p.levelInfo === 2
        );
        
        let total = 0;
        let selected = 0;
        
        if (allLevel2.length === 0) {
          // If no level 2 children, check if level 1 has direct level 3 children
          const directLevel3 = permissionData.filter(
            (p: any) => p.parentId === row.permissionId && p.levelInfo === 3
          );
          if (directLevel3.length > 0) {
            total = directLevel3.length;
            selected = directLevel3.filter((p: any) => p.selected).length;
          }
          // If still no children, total remains 0 and we'll use row.selected
        } else {
          allLevel2.forEach((level2Item: any) => {
            const level3 = permissionData.filter(
              (p: any) => p.parentId === level2Item.permissionId && p.levelInfo === 3
            );
            
            if (level3.length > 0) {
              // If level 3 exists, count them
              total += level3.length;
              selected += level3.filter((p: any) => p.selected).length;
            } else {
              // If no level 3, count level 2 itself
              total += 1;
              if (level2Item.selected) {
                selected += 1;
              }
            }
          });
        }
        
        // If the main row itself is selected, keep it checked regardless of children state
        // Only calculate based on children if the main row is not explicitly selected
        const allChecked = row.selected ? true : (total > 0 ? (selected === total) : row.selected);
        const someChecked = row.selected ? (total > 0 && selected < total) : (total > 0 && selected > 0 && selected < total);
        
        // Check if this category is expanded
        const isExpanded = extraData?.expandedCategories?.has(row.permissionId) || false;
        const isAdministration = extraData?.roleName && extraData.roleName.toLowerCase() === "administration";
        
        return (
          <div className="categoryRowContent">
            <input
              type="checkbox"
              checked={allChecked}
              disabled={isAdministration}
              ref={(el: any) => { 
                if (el) el.indeterminate = someChecked; 
              }}
              onChange={(e) => {
                e.stopPropagation();
                if (isAdministration) return;
                const newState = total > 0 ? !allChecked : !row.selected;
                const handleOnSelect = extraData?.handleOnSelect;
                if (handleOnSelect && row.levelInfo === 1) {
                  // For level 1 categories, handleOnSelect will handle all children
                  handleOnSelect(row, newState);
                }
              }}
              onClick={(e) => e.stopPropagation()}
              className="categoryCheckbox"
            />
            <div className="categoryClickArea">
              <span className="categoryTitle">{cell}</span>
              {total > 0 && (
                <span className="permission-count countBadge">
                  {selected}/{total}
                </span>
              )}
            </div>
          </div>
        );
      }
      return cell;
    },
    formatExtraData: { permissionData: [] },
  },
];

const tcolumns = [
  {
    dataField: "displayPermissionName",
    text: "",
    formatter: (cell: any, row: any, rowIndex: any, extraData: any) => {
      const permissionData = extraData?.permissionData || [];
      
      if (row.levelInfo === 2) {
        // Level 2: Get count of level 3 children
        const level3 = permissionData.filter(
          (p: any) => p.parentId === row.permissionId && p.levelInfo === 3
        );
        const selected = level3.filter((p: any) => p.selected).length;
        const total = level3.length;
        // If the subcategory itself is selected, keep it checked regardless of children state
        // Only calculate based on children if the subcategory is not explicitly selected
        const allChecked = row.selected ? true : (total > 0 ? (selected === total) : row.selected);
        const someChecked = row.selected ? (total > 0 && selected < total) : (total > 0 && selected > 0 && selected < total);
        const hasChildren = level3.length > 0;
        const isExpanded = extraData?.expandedSubCategories?.has(row.permissionId) || false;
        const isAdministration = extraData?.roleName && extraData.roleName.toLowerCase() === "administration";
        
        return (
          <div className="subCatRowContent">
            <input
              type="checkbox"
              checked={allChecked}
              disabled={isAdministration}
              ref={(el: any) => { 
                if (el) el.indeterminate = someChecked; 
              }}
              onChange={(e) => {
                e.stopPropagation();
                if (isAdministration) return;
                const newState = total > 0 ? !allChecked : !row.selected;
                const handleOnSelect = extraData?.handleOnSelect;
                if (handleOnSelect && row.levelInfo === 2) {
                  // For level 2 subcategories, handleOnSelect will handle all children
                  handleOnSelect(row, newState);
                }
              }}
              onClick={(e) => e.stopPropagation()}
              className="subCatCheckbox"
            />
            <div className="subCatClickArea">
              <span className="subCatTitle">{cell}</span>
              {total > 0 && (
                <span className="permission-count subCountBadge">
                  {selected}/{total}
                </span>
              )}
            </div>
          </div>
        );
      } else if (row.levelInfo === 3) {
        // Level 3: Simple checkbox and name
        const isAdministration = extraData?.roleName && extraData.roleName.toLowerCase() === "administration";
        return (
          <div className="actionRowContent">
            <input
              type="checkbox"
              checked={row.selected}
              disabled={isAdministration}
              onChange={(e) => {
                e.stopPropagation();
                if (isAdministration) return;
                const handleOnSelect = extraData?.handleOnSelect;
                if (handleOnSelect) {
                  handleOnSelect(row, !row.selected);
                }
              }}
              onClick={(e) => e.stopPropagation()}
              className="actionCheckbox"
            />
            <span className="actionName">{cell}</span>
          </div>
        );
      }
      return cell;
    },
    formatExtraData: { permissionData: [] },
  },
];

const ucolumns = [
  {
    dataField: "userName",
    text: "User Name",
    headerFormatter: () => null, // hides content
    headerStyle: () => {
      return { display: "none" }; // removes space
    },
  },
  {
    dataField: "roleName",
    text: "Role",
    hidden: true,    
    //style:{ backgroundColor: '#c8e6c9':'none' },
    
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        
       <div style={{backgroundColor: 'none'}}>
          {row.roleName}
          </div>
      );
    },
  },
];


export class RolePermission extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      confirmPopup:false,
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      roleID:0,
      roleName:'',
      permissionData:[],
      users:[],
      activeTab: 'rolePermissions', // 'userRoles' or 'rolePermissions'
      expandedCategories: new Set(), // Track expanded categories
      expandedSubCategories: new Set(), // Track expanded subcategories
      isAllExpanded: false, // Track if all categories are expanded
      formData: {
        RoleName: "",
        RoleId: "",
        OrderNo: "",
        ResetPwd: "false",
        TenantId: 0,
        RoleTag: "",
        PermissionRoles:[]
      },
      showNewRoleTextbox:true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleResetPwd = this.handleResetPwd.bind(this);
    this.resetPermissionGrid= this.resetPermissionGrid.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
  
    let requestlist = { ...this.state.requestlist };
    this.getroledata(requestlist);
    // getPermissionData will be called automatically after Administration role is selected in getroledata
    // Only call it here if roleID is already set (not 0)
    if (this.state.roleID !== 0) {
      this.getPermissionData();
    }
    this.getAllUsers();

  }

  
  getAllUsers = () => {

    let TypeUserlist: any = [];

    User.getAllUsers()
      .then(async (result: any | null) => {

        if (result !== null) {
          this.setState({ users: result });

        }
        resolve();

      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });

    
  };

  getroledata = (requestlist: any) => {
    Roles.GetRoleData(requestlist)
      .then(async (result: any[] | null) => {
        console.log(result);
        if (result != null) {
          // If no role is selected, find and select Administration role by default
          if (this.state.roleID === 0) {
            const adminRole = result.find((r: any) => 
              r.roleName && r.roleName.toLowerCase() === "administration"
            );
            if (adminRole) {
              result.forEach(element => {
                element.selected = (element.roleID == adminRole.roleID);
              });
              // Set Administration as selected
              this.setState({ 
                searcResult: result,
                roleID: adminRole.roleID,
                roleName: adminRole.roleName
              }, () => {
                // Load permissions for Administration role
                let formData = { ...this.state.formData };
                formData.RoleName = adminRole.roleName;
                formData.RoleId = adminRole.roleID.toString();
                this.setState({ formData }, () => {
                  this.getPermissionData();
                });
              });
            } else {
              result.forEach(element => {
                element.selected = (element.roleID == this.state.roleID);
              });
              this.setState({ searcResult: result }, () => {});
            }
          } else {
            result.forEach(element => {
              element.selected = (element.roleID == this.state.roleID);
            });
            this.setState({ searcResult: result }, () => {});
          }
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  getPermissionData = () => {
    debugger;
    let requestlist = { ...this.state.requestlist };
    let formData = { ...this.state.formData };
   // requestlist.roleId = this.state.roleID==0?1:this.state.roleID;


    if (this.state.roleID == 0) {
      requestlist.roleId = 1;  // Set to "Administration" role ID (assumed ID = 1)
      formData.RoleName = "Administration";  // Set RoleName to "Administration"
    } else {
      requestlist.roleId = this.state.roleID;  // Use the provided roleID
    }
    //formData.RoleName=this.state.roleID==0?"Administration":formData.RoleName;
    Roles.GetPermissionData(requestlist)


 
      .then(async (result: any[] | null) => {
        console.log(result);
        if (result != null) {
          // If Administration role, select all permissions
          const isAdministration = formData.RoleName && formData.RoleName.toLowerCase() === "administration";
          if (isAdministration) {
            result.forEach((element: any) => {
              element.selected = true;
            });
          }
          
          // Preserve expanded state when changing roles
          this.setState({ 
            formData,
            permissionData: result,
            isSaveSpinner: false,
            showNewRoleTextbox: true
            // Keep existing expandedCategories and expandedSubCategories to preserve expanded state
          }, () => {});
        }
        resolve();
      })
      .catch((err: any) => {
        this.setState({ isSaveSpinner: false});
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  handleRoleOnSelect = (row, isSelect) => { 
    debugger;
   
    let roles = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );

    let formData = { ...this.state.formData };
   
    roles.forEach(element => {
        if(element.roleID == row.roleID)
        {
          element.selected = isSelect;
          formData.RoleName =row.roleName;
        }
        else         
          element.selected = false;
    });

  
    this.setState({ searcResult: roles,roleID:row.roleID,showNewRoleTextbox:true,formData:formData ,isSaveSpinner: true },()=>{
      this.getPermissionData();
    });

  };

  SavePermissionRole = () => {

    let request: any = {};
   let permissionRoles: any = [];
   let permissionData = this.state.permissionData;
   let storage = JSON.parse(localStorage.getItem("storage")!);
   let tenantID = storage === null ? 0 : (storage.tenantID as any);
   this.setState({ isSaveSpinner: true });
   
   // Check if it's a new role (roleID is 0 and RoleName is provided)
   const isNewRole = this.state.roleID == 0 && this.state.formData.RoleName && this.state.formData.RoleName.trim() !== '';
   
   if (this.state.formData.RoleId == 0 && (this.state.formData.RoleName == '' || this.state.formData.RoleName == undefined)) {
     toast.error("Please enter a Role Name.", {
       position: toast.POSITION.BOTTOM_RIGHT,
       containerId: "OrderSlideout",
     });
     this.setState({ isSaveSpinner: false });
     return;
   }

   // If it's a new role, first create the role
   if (isNewRole) {
     const roleRequest: any = {
       RoleName: this.state.formData.RoleName,
       TenantID: tenantID,
       RoleId: 0 // 0 indicates new role
     };
     
     Roles.SaveUserRole(roleRequest)
       .then(async (result: any | null) => {
         if (result !== null) {
           // Handle different response structures
           let newRoleId = 0;
           
           if (Array.isArray(result) && result.length > 0) {
             // If result is an array, get the first item
             newRoleId = result[0].roleID || result[0].RoleID || result[0].id || 0;
           } else if (result.roleID) {
             // If result is an object with roleID
             newRoleId = result.roleID;
           } else if (result.RoleID) {
             // If result is an object with RoleID
             newRoleId = result.RoleID;
           } else if (result.id) {
             // If result is an object with id
             newRoleId = result.id;
           } else if (typeof result === 'number') {
             // If result is directly a number
             newRoleId = result;
           }
           
           if (newRoleId > 0) {
             // Update formData with the new role ID
             let updatedFormData = { ...this.state.formData };
             updatedFormData.RoleId = newRoleId.toString();
             
             this.setState({ 
               roleID: newRoleId,
               formData: updatedFormData
             }, () => {
               // After role is created, save permissions
               this.saveRolePermissions(newRoleId, permissionData, tenantID);
               
               // Refresh role list to include the new role
               let requestlist = { ...this.state.requestlist };
               this.getroledata(requestlist);
             });
           } else {
             toast.error("Failed to create role: Invalid role ID returned.", {
               position: toast.POSITION.BOTTOM_RIGHT,
               containerId: "OrderSlideout",
             });
             this.setState({ isSaveSpinner: false });
           }
         } else {
           toast.error("Failed to create role: No response from server.", {
             position: toast.POSITION.BOTTOM_RIGHT,
             containerId: "OrderSlideout",
           });
           this.setState({ isSaveSpinner: false });
         }
       })
       .catch((error: any) => {
         console.error("Error creating role:", error);
         const errorMessage = error?.response?.data?.message || error?.message || error || "Unknown error";
         toast.error(`Failed to create role: ${errorMessage}`, {
           position: toast.POSITION.BOTTOM_RIGHT,
           containerId: "OrderSlideout",
         });
         this.setState({ isSaveSpinner: false });
       });
   } else {
     // Existing role - save permissions directly
     this.saveRolePermissions(this.state.roleID, permissionData, tenantID);
   }
  };

  saveRolePermissions = (roleId: number, permissionData: any[], tenantID: number) => {
    let permissionRoles: any = [];
    
    permissionData.forEach(element => {
      let item: any = {};
      if(element.selected || this.state.formData.RoleName.toLowerCase() == 'administration')
      {
        item.PermissionID = element.permissionId;
        item.RoleID = roleId;
        item.TenantID = tenantID;
        permissionRoles.push(item);
      }
    });

    let formData = { ...this.state.formData };
    formData.RoleId = roleId;
    formData.PermissionRoles = permissionRoles;
    
    const request = Object.assign(
      {},
      JSON.parse(JSON.stringify(formData))
    );
    
    Roles.SavePermissionRole(request)
      .then(async (result: any | null) => { 
        if (result !== null) {
          toast.success("Role permission has been saved successfully.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          // Refresh role list to include the new role
          let requestlist = { ...this.state.requestlist };
          this.getroledata(requestlist);
          // Update state with the new role ID
          this.setState({ 
            roleID: roleId,
            formData: formData,
            showNewRoleTextbox: true // Switch back to dropdown view
          });
        }
        
        this.setState({ isSaveSpinner: false, isStateChanged: false });
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSaveSpinner: false });
        toast.error(`Failed to save permissions: ${error}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        reject();
      });
  };

  handleDiscard = () => {
    debugger;
    this.resetPermissionGrid();
    this.setState({ isStateChanged: false,showNewRoleTextbox: true });

  };

  showNewRoleTextbox = () => {
    this.resetPermissionGrid();
    let formData = { ...this.state.formData };
    formData.RoleName = ""; 
    formData.RoleId = "";
    this.setState({ 
      showNewRoleTextbox: false, // false shows the input field for new role
      roleID: 0,
      formData,
      isStateChanged: false
    });
  };

  resetPermissionGrid = () => 
  {
    debugger;
    let permissionData = this.state.permissionData;


    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        
      },
    }));

    permissionData.forEach(element => {
      element.selected = false;
    });
    this.setState({ permissionData:permissionData });
  };

  handleDeleteRole = (role: any) => {
  if (!role || !role.roleID) {
    toast.error("Invalid role selected.", {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "OrderSlideout",
    });
    return;
  }

  // Prevent deleting Administration role
  if (role.roleName && role.roleName.toLowerCase() === "administration") {
    toast.error("Cannot delete Administration role.", {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "OrderSlideout",
    });
    return;
  }

  // Check if users are assigned to this role
  const assignedUsers = this.state.users.filter(
    (u: any) => u.role === role.roleID
  );

  if (assignedUsers.length > 0) {
    const count = assignedUsers.length;
    const userText = count === 1 ? "user is" : "users are";

    toast.error(
      `Cannot delete role "${role.roleName}". ${count} ${userText} assigned. Reassign users first.`,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      }
    );
    return;
  }


  confirmAlert({
    title: "Delete Role",
    message: `Are you sure you want to delete the role "${role.roleName}"?`,
    buttons: [
      {
        label: "Yes",
        onClick: () => this.executeDeleteRole(role)
      },
      {
        label: "No",
        onClick: () => {} 
      }
    ],
    closeOnEscape: false,
    closeOnClickOutside: false
  });
};

executeDeleteRole = (role: any) => {
  this.setState({ isSaveSpinner: true });


  Roles.DeleteRole({id:role.roleID})
    .then((result: any | null) => {
      if (result !== null) {
        toast.success("Role deleted successfully.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });

        
        this.setState({isSaveSpinner: false,roleID:0},()=>{
         this.getroledata({ ...this.state.requestlist });
        });
      } else {
        this.setState({ isSaveSpinner: false });
      }
    })
    .catch((error: any) => {
      toast.error(`Failed to delete role: ${error}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false });
    });
};


  closeSlideOut = () => {
    this.setState({ showSlideout: false });
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({
        showSlideout: false,
        templateid: row.id,
        roleID:row.roleID,
        roleName:row.roleName
        
      },()=>{
        
      });
    },
  };

  handleChange = (event: any, FieldType: string) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;
    debugger;

    let formData = { ...this.state.formData };

    if (FieldType === "RoleName") {
      formData.RoleName =
        event.target.value.trim().length > 0 ? event.target.value : "";
       
    } else if (FieldType === "OrderNo") {
      formData.OrderNo =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "ResetPwd") {
      /// this.generateUsername;
      formData.ResetPwd =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "RoleTag") {
      formData.RoleTag =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }

    this.setState({ formData, isStateChanged, isSpinner: false }, () => {
      // if (FieldType === "invoiceno") {
      //   let txtID = "txtInvoice";
      //   let txtInvoice = $("input[id^='" + txtID + "']")[0] as any;
      //   txtInvoice.selectionStart = start;
      //   txtInvoice.selectionEnd = end;
      // }
    });
  };


  rowStyle = (row, rowIndex) => {
    if (row.selected) {
      return {
        backgroundColor: '#c8e6c9',
        fontWeight: 'bold',
        borderLeft: '4px solid #388e3c'
      };
    }
    return {};
  };

  permissionRowStyle = (row, rowIndex) => {
    // Level 1 categories - no background color
    if (row.levelInfo === 1) {
      return {
        backgroundColor: 'transparent',
        color: '#000000',
        border: 'none',
        borderRadius: '8px',
        marginBottom: '8px'
      };
    }
    return {};
  };

  permissionRowClasses = (row, rowIndex) => {
    if (row.levelInfo === 1) {
      return 'categoryRow';
    }
    return '';
  };



  handleResetPwd = (event: any) => {
    const ResetPwd = event.target.checked;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        ResetPwd,
      },
    }));
  };

  handleTabChange = (tab: string) => {
    this.setState({ activeTab: tab });
  };

  toggleCategory = (categoryId: number) => {
    this.setState((prevState: any) => {
      const expanded = new Set(prevState.expandedCategories || []);
      if (expanded.has(categoryId)) {
        expanded.delete(categoryId);
      } else {
        expanded.add(categoryId);
      }
      return { expandedCategories: expanded };
    });
  };

  toggleSubCategory = (subCategoryId: number) => {
    this.setState((prevState: any) => {
      const expanded = new Set(prevState.expandedSubCategories || []);
      if (expanded.has(subCategoryId)) {
        expanded.delete(subCategoryId);
      } else {
        expanded.add(subCategoryId);
      }
      return { expandedSubCategories: expanded };
    });
  };

  expandAllCategories = () => {
    const { permissionData } = this.state;
    const allCategories = permissionData.filter((x: any) => x.levelInfo === 1);
    const allSubCategories = permissionData.filter((x: any) => x.levelInfo === 2);
    
    this.setState({
      expandedCategories: new Set(allCategories.map((r: any) => r.permissionId)),
      expandedSubCategories: new Set(allSubCategories.map((r: any) => r.permissionId)),
      isAllExpanded: true
    });
  };

  collapseAllCategories = () => {
    this.setState({
      expandedCategories: new Set(),
      expandedSubCategories: new Set(),
      isAllExpanded: false
    });
  };

  toggleExpandAll = () => {
    if (this.state.isAllExpanded) {
      this.collapseAllCategories();
    } else {
      this.expandAllCategories();
    }
  };


  handleOnSelect = (row, isSelect) => {
    // Prevent changes for Administration role
    if (this.state.formData.RoleName && this.state.formData.RoleName.toLowerCase() === "administration") {
      return;
    }
    
    let permissionData = JSON.parse(JSON.stringify(this.state.permissionData));
    let listItem: any[] = [];
  
    if (row.levelInfo === 1) {
      // Level 1 (Category): Select/unselect this category and ALL its children
      listItem.push(...permissionData.filter(x => x.permissionId === row.permissionId));
      
      // Get all level 2 children (subcategories)
      const level2Children = permissionData.filter(
        (x: any) => x.parentId === row.permissionId && x.levelInfo === 2
      );
      listItem.push(...level2Children);
      
      // Get all level 3 children (actions) - both direct and through level 2
      const level3Children = permissionData.filter(
        (x: any) => {
          // Direct children of this category
          if (x.parentId === row.permissionId && x.levelInfo === 3) return true;
          // Children through level 2
          return level2Children.some((l2: any) => l2.permissionId === x.parentId) && x.levelInfo === 3;
        }
      );
      listItem.push(...level3Children);
      
    } else if (row.levelInfo === 2) {
      // Select or unselect this level 2 item
      listItem.push(...permissionData.filter(x => x.permissionId === row.permissionId));
      
      // Always select/unselect all level 3 children
      const level3Children = permissionData.filter(
        (x: any) => x.parentId === row.permissionId && x.levelInfo === 3
      );
      listItem.push(...level3Children);
      
      if (isSelect) {
        // If selecting, also select parent (level 1)
        const parent = permissionData.find(x => x.permissionId === row.parentId);
        if (parent) listItem.push(parent);
      }
  
    } else if (row.levelInfo === 3) {
      // Always toggle the level 3 item
      listItem.push(...permissionData.filter(x => x.permissionId === row.permissionId));
  
      if (isSelect) {
        // If selecting, also select parent (level 2)
        const parent = permissionData.find(x => x.permissionId === row.parentId);
        if (parent) listItem.push(parent);
  
        // And grandparent (level 1)
        const grandParent = permissionData.find(x => x.permissionId === parent?.parentId);
        if (grandParent) listItem.push(grandParent);
      }
  
      // ❌ If unselecting level 3, do NOT unselect parent (level 2 or 1)
    }
  
    // Apply selected state
    listItem.forEach(element => {
      element.selected = isSelect;
    });
  
    this.setState({ permissionData, isStateChanged: true });
  };
  

  handleOnSelectAll = (isSelect, rows) => {
    
    const ids = rows.map(r => r.permissionId);
    const pids = rows.map(r => r.parentId);

    let permissionData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.permissionData))
    );

    let listItems:any = [];

    if(rows[0].levelInfo == 2)
    {
      listItems = permissionData.filter(
        (x) => ids.includes(x.permissionId) || ids.includes(x.parentId)
      );
    }
    else if(rows[0].levelInfo == 3)
    {
      listItems = permissionData.filter(
        (x) => ids.includes(x.permissionId) || pids.includes(x.permissionId)
      );
    }

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    };

   this.setState({ permissionData: permissionData,isStateChanged:true });
  };

 

  
  render() {
    const { showSlideout, permissionData, users, searcResult, isStateChanged } = this.state;
    const roleName = this.state.formData.RoleName || this.state.roleName || '';
  
    // First Level Expansion (Permissions)
    const expandSplitRow = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any) => renderItemTableChild(row),
      expanded: Array.from(this.state.expandedCategories || []),
      showExpandColumn: true, // Show expand column for functionality
      expandByColumnOnly: false, // Allow clicking anywhere on row to expand
      nonExpandable: permissionData
        .filter(x => x.levelInfo === 1)
        .filter(row => {
          // Check if this row has any children (level 2 or level 3)
          const hasLevel2 = permissionData.some(
            child => child.parentId === row.permissionId && child.levelInfo === 2
          );
          const hasLevel3 = permissionData.some(
            child => child.parentId === row.permissionId && child.levelInfo === 3
          );
          return !hasLevel2 && !hasLevel3; // Not expandable if no children
        })
        .map(row => row.permissionId),
      onExpand: (row: any, isExpand: boolean) => {
        this.toggleCategory(row.permissionId);
      },
      expandHeaderColumnRenderer: () => <div></div>, // Hide expand column header
      expandColumnRenderer: ({ expanded, expandable }) => {
        // Don't show arrow if not expandable
        if (!expandable) return null;
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };
  
    // Second Level Expansion (Child Permissions)
    const expandSplitRow2 = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any) => renderItemTableChild2(row),
      expanded: Array.from(this.state.expandedSubCategories || []),
      showExpandColumn: true, // Show expand column for functionality
      expandByColumnOnly: false, // Allow clicking anywhere on row to expand
      nonExpandable: permissionData
        .filter(x => x.levelInfo === 2)    
        .filter(row => 
          !permissionData.some(
            child => child.parentId === row.permissionId && child.levelInfo === 3
          )
        )
        .map(row => row.permissionId),
      onExpand: (row: any, isExpand: boolean) => {
        this.toggleSubCategory(row.permissionId);
      },
      expandHeaderColumnRenderer: () => <div></div>, // Hide expand column header
      expandColumnRenderer: ({ expanded, expandable }) => {
        if (!expandable) return null;
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };
  
    // First Child Renderer
    const renderItemTableChild = (mainrow: any) => {
      const splitDetail = permissionData.filter(
        (x) => x.parentId === mainrow.permissionId && x.levelInfo === 2
      );

      return (
        <div className="subcategory-container">
          <BootstrapTable
            keyField="permissionId"
            data={splitDetail}
            columns={tcolumns.map(col => ({
              ...col,
              formatExtraData: { 
                permissionData,
                expandedSubCategories: this.state.expandedSubCategories || new Set(),
                handleOnSelect: this.handleOnSelect,
                roleName: this.state.formData.RoleName
              }
            }))}
            expandRow={expandSplitRow2}
            rowEvents={{
              onClick: (e: any, row: any, rowIndex: number) => {
                // Prevent expansion when clicking on checkbox
                if (e.target.type === 'checkbox' || 
                    e.target.closest('input[type="checkbox"]') || 
                    e.target.closest('.subCatCheckbox')) {
                  e.stopPropagation();
                  return;
                }
                // Check if row is expandable (has level 3 children)
                const hasLevel3 = permissionData.some(
                  child => child.parentId === row.permissionId && child.levelInfo === 3
                );
                
                // If expandable, toggle expansion
                if (hasLevel3) {
                  this.toggleSubCategory(row.permissionId);
                }
              }
            }}
            selectRow={{
              mode: "checkbox",
              clickToSelect: false,
              selected: splitDetail.filter((x) => x.selected).map(r => r.permissionId),
              onSelect: this.handleOnSelect,
              onSelectAll: this.handleOnSelectAll,
            }}
          />
        </div>
      );
    };
  
    // Second Child Renderer
    const renderItemTableChild2 = (mainrow: any) => {
      const splitDetail2 = permissionData.filter(
        (x) => x.parentId === mainrow.permissionId && x.levelInfo === 3
      );

      return (
        <div className="actionsList">
          <BootstrapTable
            keyField="permissionId"
            data={splitDetail2}
            columns={tcolumns.map(col => ({
              ...col,
              formatExtraData: { 
                permissionData,
                expandedSubCategories: this.state.expandedSubCategories,
                handleOnSelect: this.handleOnSelect,
                roleName: this.state.formData.RoleName
              }
            }))}
            rowEvents={{
              onClick: (e: any, row: any, rowIndex: number) => {
                // Allow checkbox clicks to work - don't interfere
                if (e.target.type === 'checkbox' || e.target.closest('input[type="checkbox"]')) {
                  return;
                }
              }
            }}
            selectRow={{
              mode: "checkbox",
              clickToSelect: false,
              selected: splitDetail2.filter((x) => x.selected).map(r => r.permissionId),
              onSelect: this.handleOnSelect,
              onSelectAll: this.handleOnSelectAll,
              hideSelectColumn: true, // Hide default checkbox column since we use custom checkboxes
            }}
          />
        </div>
      );
    };
  
    // User Expansion
    const expandUser = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any) => renderItemTableChildUser(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandColumnRenderer: ({ expanded }) => (
        <span className="chevronCollpsed">
          <img src={chevronRight} alt="chevron Right" />
        </span>
      ),
    };
  
    // User Table Renderer
    const renderItemTableChildUser = (mainrow: any) => {
      const userdetails = users.filter((x) => x.role === mainrow.roleID);
  
      return (
        <div className="pt-4 ps-5">
          <BootstrapTable keyField="user_UniqueID" data={userdetails} columns={ucolumns} />
        </div>
      );
    };
  
    const { activeTab } = this.state;
    const selectedRole = searcResult.find((r: any) => r.selected);
    const assignedUsers = users.filter((u: any) => u.role === this.state.roleID);

    return (
      <React.Fragment>
        <Container fluid className="body-sec role-permission-page">
          <div className="page-heading underline d-flex">
            Roles & Permissions
            <div className="action-group d-flex flex-row ml-auto">
              <Button onClick={this.showNewRoleTextbox} className="btn-primary">+ Add Role</Button>
            </div>
          </div>

          {/* Tab Navigation - Hidden */}
          <div className="role-permission-tabs" style={{ display: 'none' }}>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'userRoles' ? 'active' : ''}`}
                  onClick={() => this.handleTabChange('userRoles')}
                >
                  User Roles
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'rolePermissions' ? 'active' : ''}`}
                  onClick={() => this.handleTabChange('rolePermissions')}
                >
                  Role Permissions
                </button>
              </li>
            </ul>
          </div>

          <div className="container-fluid my-3">
            <div className="row">
              {/* Permissions Table */}
              <div className="col-12">
                <div className="configure-permissions-section">
                  <div className="perm-header">
                    <div>
                      <h2 className="card-title">Configure Permissions</h2>
                      <p className="subtitle">Select a role and expand categories to manage permissions</p>
                    </div>
                    <div className="actions-group" style={{paddingRight: '2%'}}>
                      <div className="expand-collapse-buttons">
                        <Button 
                          variant="outline-secondary" 
                          size="sm"
                          onClick={this.toggleExpandAll}
                          className="expand-collapse-btn"
                        >
                          {this.state.isAllExpanded ? "Collapse All" : "Expand All"}
                        </Button>
                      </div>
                      <div className="role-selector-area">
                      {this.state.showNewRoleTextbox ? (
                        <>
                          {/* <Form.Control 
                            as="select"
                            className={`role-select ${this.state.roleID ? 'role-selected' : ''}`}
                            value={this.state.roleID || ""}
                            onChange={(e: any) => {
                              const roleId = parseInt(e.target.value);
                              const role = searcResult.find((r: any) => r.roleID === roleId);
                              if (role) {
                                this.handleRoleOnSelect(role, true);
                              }
                            }}
                          >
                            <option value="">Select Role</option>
                            {searcResult.map((role: any) => (
                              <option 
                                key={role.roleID} 
                                value={role.roleID}
                              >
                                {role.roleName}
                              </option>
                            ))}
                          </Form.Control> */}
                          <div className="col-12 col-md-10">
                          <Dropdown
                            className="more-action bg-blue-bank single-select-image"
                            style={{ minWidth: "160px" }}
                          >
                            <Dropdown.Toggle
                              id="roleDropdown"
                              className={`filter-btn ${!this.state.roleID ? "" : ""}`}
                            >
                              <div className="d-flex align-items-center">
                                <div className="txt-area">
                                  <EllipsisWithTooltip placement="bottom">
                                    {this.state.roleID
                                      ? searcResult.find((r: any) => r.roleID === this.state.roleID)?.roleName
                                      : "Select Role"}
                                  </EllipsisWithTooltip>
                                </div>

                                <div className="drop-arrow ml-0 d-flex">
                                  <FiChevronDown />
                                </div>
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: "100%" }}>
                              <div className="list-area">

                                {searcResult.map((role: any, idx: number) => (
                                  <Dropdown.Item
                                    key={idx}
                                    onClick={() => this.handleRoleOnSelect(role, true)}
                                  >
                                    <EllipsisWithTooltip placement="bottom">
                                      {role.roleName}
                                    </EllipsisWithTooltip>
                                  </Dropdown.Item>
                                ))}

                              </div>
                            </Dropdown.Menu>
                          </Dropdown></div>


                          {selectedRole &&  (
                            <button className="delete-role-btn" title="Delete Role" onClick={() => {
                                this.handleDeleteRole(selectedRole);
                            }}>
                              🗑️
                            </button>
                          )}
                        </>
                      ) : (
                        <div className="role-name-input">
                          <Form.Control 
                            placeholder="Enter RoleName or Select"
                            value={this.state.formData.RoleName==undefined ? "" :this.state.formData.RoleName }
                            disabled={this.state.formData.RoleName==undefined ? true : this.state.formData.RoleName.toLowerCase() === "administration"?true :false}
                            onChange={(event: any) => this.handleChange(event, "RoleName")} 
                          />
                        </div>
                      )}
                      </div>
                    </div>
                  </div>

                  {/* Assigned To Section */}
                  {selectedRole && (
                    <div className="assignedUsersBar">
                      {assignedUsers.length > 0 ? (
                        <>
                          <span className="assignedLabel">Assigned to:</span>
                          {assignedUsers.map((user: any, index: number) => (
                            <span key={index} className="userChip">
                              {user.userName || user.name || `User ${index + 1}`}
                            </span>
                          ))}
                        </>
                      ) : (
                        <span className="noUsersLabel">No users assigned to this role</span>
                      )}
                    </div>
                  )}

                  {/* Permissions Tree */}
                  <div className="permission-tree-container permList">
                    <div className="permission-scroll-area mt-4" style={{ paddingRight: "10px" }}>
                      <BootstrapTable
                        keyField="permissionId"
                        data={permissionData.filter((a) => a.levelInfo === 1)}
                        columns={pcolumns.map(col => ({
                          ...col,
                          formatExtraData: { 
                            permissionData,
                            expandedCategories: this.state.expandedCategories || new Set(),
                            handleOnSelect: this.handleOnSelect,
                            roleName: this.state.formData.RoleName
                          }
                        }))}
                        expandRow={expandSplitRow}
                        rowStyle={this.permissionRowStyle}
                        rowClasses={this.permissionRowClasses}
                        rowEvents={{
                          onClick: (e: any, row: any, rowIndex: number) => {
                            // Prevent expansion when clicking on checkbox only
                            if (e.target.type === 'checkbox' || 
                                e.target.closest('input[type="checkbox"]') || 
                                e.target.closest('.categoryCheckbox')) {
                              e.stopPropagation();
                              return;
                            }
                            // Check if row is expandable (has children)
                            const hasLevel2 = permissionData.some(
                              child => child.parentId === row.permissionId && child.levelInfo === 2
                            );
                            const hasLevel3 = permissionData.some(
                              child => child.parentId === row.permissionId && child.levelInfo === 3
                            );
                            
                            // If expandable, toggle expansion
                            if (hasLevel2 || hasLevel3) {
                              this.toggleCategory(row.permissionId);
                            }
                          }
                        }}
                        selectRow={{
                          mode: "checkbox",
                          clickToSelect: false,
                          selected: permissionData.filter((a) => a.levelInfo === 1 && a.selected).map(r => r.permissionId),
                          onSelect: this.handleOnSelect,
                          hideSelectColumn: true, // Hide default checkbox column
                        }}
                        classes="categoryBlock"
                      />
                    </div>
                  </div>

                  {/* Save & Discard Buttons */}
                  {((isStateChanged || !this.state.showNewRoleTextbox) && (!roleName || (roleName && roleName.trim() === '') || (roleName && roleName.toLowerCase() !== "administration"))) && (
                    <div className="TabFooter-Pay">
                      <div className="fixed-action">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div className="message">
                            <span>{isStateChanged ? "You have unsaved changes" : "Add new role"}</span>
                          </div>
                          <div className="d-flex gap-2">
                            <Button variant="outline-secondary" className="btn btn-discard" onClick={this.handleDiscard}>
                              Discard
                            </Button>
                            <Button id="btnSave" variant="primary" className="btn btn-primary" onClick={this.SavePermissionRole}>
                              {this.state.roleID > 0 ? "Update" : "Save"}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {showSlideout && <RolePremissionSlideout closeSlideOut={this.closeSlideOut} templateid={this.state.templateid} />}

        </Container>

        {(this.state.isSpinner || this.state.isSaveSpinner) && (
          <div className="loader-spinner d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="success" />
          </div>
        )}
      </React.Fragment>
    );
  }
  
}